import { P_VENDOR_SETTING } from '@/constants/modules/p-vendor';
import { P_SKU_SETTING } from '@/constants/modules/p-sku';
import { P_PRICE_SETTING } from '@/constants/modules/p-price';
import { P_TITLE_SETTING } from '@/constants/modules/p-title';
import { P_DESCRIPTION_SETTING } from '@/constants/modules/p-description';
import { P_FILE_UPLOAD_SETTING } from '@/constants/modules/p-file-upload';
import { DYNAMIC_BUTTON_SETTING } from '@/constants/modules/dynamic-button';
import { P_CART_BUTTON_SETTING } from '@/constants/modules/p-cart-button';
import { P_VIEW_MORE_SETTING } from '@/constants/modules/p-view-more';
// import { P_SWATCHES_SETTING } from "@/constants/modules/p-swatches";
// import { P_VARIANTS_SETTING } from "@/constants/modules/p-variants";
// import { P_QUANTITY_SETTING } from "@/constants/modules/p-quantity";
import { P_IMAGE_SETTING } from '@/constants/modules/p-image';

export const SETTING_PRODUCTS = {
  'p-vendor': P_VENDOR_SETTING,
  'p-sku': P_SKU_SETTING,
  'p-price': P_PRICE_SETTING,
  'p-title': P_TITLE_SETTING,
  'p-description': P_DESCRIPTION_SETTING,
  'p-file-upload': P_FILE_UPLOAD_SETTING,
  'dynamic-button': DYNAMIC_BUTTON_SETTING,
  'p-cart-button': P_CART_BUTTON_SETTING,
  'p-view-more': P_VIEW_MORE_SETTING,
  // "p-swatches": P_SWATCHES_SETTING,
  // "p-variants": P_VARIANTS_SETTING,
  // "p-quantity": P_QUANTITY_SETTING,
  'p-image': P_IMAGE_SETTING,
};
